import { ArrowDown, Link } from '@phosphor-icons/react'
import { Separator } from '@/components/ui/separator'

interface ChainIndicatorProps {
  label: string
}

export function ChainIndicator({ label }: ChainIndicatorProps) {
  return (
    <div className="flex items-center gap-3 py-1">
      <div className="flex flex-col items-center">
        <Separator orientation="vertical" className="h-4" />
        <ArrowDown weight="bold" className="w-3.5 h-3.5 text-primary/50" />
        <Separator orientation="vertical" className="h-4" />
      </div>
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-primary/[0.04] border border-primary/[0.12]">
        <Link weight="regular" className="w-3.5 h-3.5 text-primary/70" />
        <span className="text-[11px] text-primary/80 font-medium">{label}</span>
      </div>
    </div>
  )
}
